import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;
  @Input() pageTitle: string | null = '';
  populations = Populations;
  isKid: boolean;
  constructor(private populationQuery: PopulationQuery) {}
  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }
}
